import { Feature, PermanentFeature } from "~/shared/util/feature"
import { hideInternalFeatures } from "~/shared/util/showInternalFeatures"
import viewManager from "~/shared/util/viewManager"

export { Feature, PermanentFeature }

const INTERNAL_FEATURES: Set<Feature | PermanentFeature> = new Set([
  Feature.InternalFeatures,
])

export function isFeatureEnabled(feature: Feature | PermanentFeature): boolean {
  if (hideInternalFeatures() && INTERNAL_FEATURES.has(feature)) {
    return false
  }
  return viewManager.get("features")[feature]
}
